import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, MenuItem, Button, CircularProgress } from '@mui/material';
import { submitBugReport } from '../api';

export default function BugReportPage() {
  const [form, setForm] = useState({ title: '', description: '', severity: 'medium', page: '', device: '', app_version: '' });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess(false);
    setError('');
    try {
      await submitBugReport(form);
      setSuccess(true);
      setForm({ title: '', description: '', severity: 'medium', page: '', device: '', app_version: '' });
    } catch (err) {
      setError(err.message || 'Failed to submit bug.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4, px: { xs: 2, sm: 0 } }}>
      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Report a Bug</Typography>
        <form onSubmit={handleSubmit}>
          <TextField label="Title" name="title" value={form.title} onChange={handleChange} fullWidth required sx={{ mb: 2 }} />
          <TextField label="Description" name="description" value={form.description} onChange={handleChange} fullWidth required multiline minRows={4} sx={{ mb: 2 }} />
          
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' }, 
            gap: 2, 
            mb: 2,
            alignItems: { xs: 'stretch', sm: 'flex-start' }
          }}>
            <TextField 
              select 
              label="Severity" 
              name="severity" 
              value={form.severity} 
              onChange={handleChange} 
              sx={{ minWidth: { xs: '100%', sm: 180 } }}
            >
              <MenuItem value="low">Low</MenuItem>
              <MenuItem value="medium">Medium</MenuItem>
              <MenuItem value="high">High</MenuItem>
              <MenuItem value="critical">Critical</MenuItem>
            </TextField>
            <TextField 
              label="Page/Screen" 
              name="page" 
              value={form.page} 
              onChange={handleChange} 
              sx={{ minWidth: { xs: '100%', sm: 240 } }} 
            />
            <TextField 
              label="Device/Browser" 
              name="device" 
              value={form.device} 
              onChange={handleChange} 
              sx={{ minWidth: { xs: '100%', sm: 240 } }} 
            />
          </Box>
          
          {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
          {success && <Typography color="success.main" sx={{ mb: 2 }}>Thanks! Your report has been submitted.</Typography>}
          <Button type="submit" variant="contained" disabled={submitting} fullWidth sx={{ mt: 2 }}>
            {submitting ? <CircularProgress size={22} color="inherit" /> : 'Submit Bug'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}


